export type NotificationData = Record<string, string | undefined>

function normalizeRoute(route: string): string {
  const trimmed = route.trim()
  if (!trimmed) return '/'
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

export function resolveNotificationRoute(data: NotificationData = {}): string {
  if (data.route) return normalizeRoute(data.route)
  if (data.deepLink) return normalizeRoute(data.deepLink)

  switch (data.type) {
    case 'session_reminder':
    case 'new_speaker_session':
      return data.sessionId ? `/sessions/${data.sessionId}` : '/sessions'
    case 'prayer_reminder':
    case 'jumuah_reminder':
      if (data.mosqueId) {
        const query = data.prayerName
          ? `?from=prayer&prayer=${encodeURIComponent(data.prayerName)}`
          : '?from=prayer'
        return `/locations/${data.mosqueId}${query}`
      }
      {
        const prayerQuery = data.prayerName
          ? `&prayer=${encodeURIComponent(data.prayerName)}`
          : ''
        return `/discover?filter=mosque&from=prayer${prayerQuery}`
      }
    default:
      return '/'
  }
}
